import React, { useEffect } from 'react'
import classes from './ProlongationFiles.module.css'
import { Grid, Table, Tbody, Thead, Th, Tr, Flex, Button, Heading, useDisclosure, Td, useToast } from '@chakra-ui/react'
import ProlongationFileModal from '../../components/Modals/ProlongationFileModal'
import StudentsService from '../../API/StudentsService'
import { useAnalyticsStore } from '../../store/analyticsStore'
import { DeleteIcon, EditIcon } from '@chakra-ui/icons'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import { toastError, toastSuccess } from '../../utils/globalHelper'
import { months } from '../../utils/constants'
import { useConfirmationModalStore, useProlongationFilesModalStore } from '../../store/modalsStore'

function ProlongationFiles() {
    const toast = useToast()
    const [prolongationFiles, setProlongationFiles] = useAnalyticsStore(state => [state.prolongationFiles, state.setProlongationFiles])
    const modalDisclosure = useDisclosure()
    const [confirmationModalDisclosure, setConfirmationModalState] = useConfirmationModalStore(
        state => [state.disclosure, state.setState]
    )
    const [setIsEditModal, setFileModalState] = useProlongationFilesModalStore(state => [state.setIsEdit, state.setState])

    const getProlongationFiles = useAccessAPI(StudentsService.getProlongationFiles)
    const deleteProlongationFile = useAccessAPI(StudentsService.deleteProlongationFile)

    useEffect(() => {
        async function fetchFiles() {
            const response = await getProlongationFiles()
            if (response?.status === 200)
                setProlongationFiles(response?.data?.results)
        }

        if (prolongationFiles?.length < 1)
            fetchFiles()
    }, [])

    const deleteFile = async (file) => {
        const response = await deleteProlongationFile(file.id)
        if (response?.status === 204) {
            setProlongationFiles(prolongationFiles.filter(f => f.id !== file.id))
            toast(toastSuccess(`Выгрузка ${file.title} удалена`))
        }
        else {
            toast(toastError("Не удалось удалить выгрузку"))
        }
    }

    const showModal = (isEdit, file) => {
        setIsEditModal(isEdit)
        setFileModalState(!isEdit ? null : {
            file_id: file.id,
            date: file.prolongation_date.substring(0, 7),
            title: file.title,
            file: null
        })
        modalDisclosure.onOpen()
    }

    return (
        <>
        <ProlongationFileModal
            isOpen={modalDisclosure.isOpen}
            onClose={modalDisclosure.onClose}
        />
        <Grid className={classes.container}>
            <Flex
                gap='var(--default-gap)'
                alignItems='center'
            >
                <Heading as='h3' size='lg'>Выгрузки продлений</Heading>
                <Button onClick={() => showModal(false, null)}>
                    Добавить выгрузку
                </Button>
            </Flex>
            <div className={classes.table}>
                <Table>
                    <Thead>
                        <Tr>
                            <Th>Год обучения</Th>
                            <Th>Месяц продления</Th>
                            <Th>Название выгрузки</Th>
                            <Th>Создание</Th>
                            <Th>Обновление</Th>
                            <Th></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {prolongationFiles.map(file => (
                            <Tr key={`prolong-file-${file.id}`}>
                                <Td>{file.prolongation_date.substring(0, 4)}</Td>
                                <Td>{months[(new Date(file.prolongation_date)).getMonth()].name}</Td>
                                <Td>{file.title}</Td>
                                <Td>
                                    {/* {`${file.created_by.lastname} ${file.created_by.firstname}, ${(new Date(file.created_at)).toLocaleString()}`} */}
                                    {`User(id=${file.created_by_id}), ${(new Date(file.created_at)).toLocaleString()}`}
                                </Td>
                                <Td>
                                    {
                                    file.updated_by_id &&
                                    // `${file.updated_by.lastname} ${file.updated_by.firstname}, ${(new Date(file.updated_at)).toLocaleString()}`
                                    `User(id=${file.updated_by_id}), ${(new Date(file.created_at)).toLocaleString()}`
                                    }
                                </Td>
                                <Td>
                                    <Flex className={classes.icons}>
                                        <EditIcon
                                            className={classes.editBtn}
                                            onClick={() => showModal(true, file)}
                                        />
                                        <DeleteIcon
                                            className={classes.deleteBtn}
                                            onClick={() => {
                                                setConfirmationModalState({
                                                    title: "Удаление выгрузки",
                                                    question: `Вы действительно хотите удалить выгрузку "${file.title}"?`,
                                                    btnText: "Удалить",
                                                    func: deleteFile,
                                                    args: [file]
                                                })
                                                confirmationModalDisclosure.onOpen()
                                            }}
                                        />
                                    </Flex>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </div>
        </Grid>
        </>
    )
}

export default ProlongationFiles
